import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=08961519"
var script = {}
import style0 from "../styles/terms-privacy.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports